import { useQuery } from "react-query";
import { TradeInApi } from "../../services";
const GET_TRADE_IN_ELIGIBILITY_QUERY_BASE_KEY = "GET_TRADE_IN_ELIGIBILITY";
const getQueryFn = () => {
    try {
        const tradeInApi = new TradeInApi();
        return () => tradeInApi.getTradeInEligibility();
    }
    catch (e) {
        return () => Promise.reject();
    }
};
export const useGetTradeInEligibility = (enabled = true) => {
    return useQuery([GET_TRADE_IN_ELIGIBILITY_QUERY_BASE_KEY], {
        queryFn: getQueryFn(),
        enabled,
    });
};
//# sourceMappingURL=useGetTradeInEligibility.js.map